<template>
    <div>
        <az-break-title title="Planos" />

        <div>

            <div class="row mb-3">
                <div class="col col-12 col-md-6">
                    <az-input icon="fas fa-search" v-model="search">
                        <template v-slot:buttonposb>
                            <importacao service="planos" :parms="{ id_operadora: id_operadora }" @refresh="load()" />
                        </template>
                    </az-input>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn text-nowrap" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn text-nowrap" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir Plano
                    </button>
                </div>
            </div>

        </div>

        <div v-if="!lista || !lista.length">
            <az-empty-state icon="fas fa-search" msg="Nenhuma operadora identificada." 
                :action="!search ? 'Incluir Operadora' : ''" :method="incluir" />
		</div>

        <div v-if="lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item" v-for="(dado, id) in lista" :key="id">
                    <div class="d-flex justify-content-between">
                        <span>
                            <i class="fas fa-square mr-2 text-muted" v-if="!dado.produtos.length"></i>
                            <a href="#" @click.prevent="collapse_planos(dado)" class="card-link mr-2" v-else>
                                <i class="far fa-plus-square" v-if="!dado.proc_count"></i>
                                <i class="far fa-minus-square" v-else></i>
                            </a>
                            <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3 ml-0">
                                {{ dado.st_plano }}
                            </a>
                        </span>
                        <span class="d-flex">
                            <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                                <input type="checkbox" class="custom-control-input" :id="'ativo-' + id" 
                                    v-model="dado.fl_ativo" 
                                    @change="toggle(dado)">
                                <label class="custom-control-label" :for="'ativo-' + id"></label>
                            </div>
                            <span v-else>
                                <span class="mr-3">{{ dado.st_codigo }}</span>
                                <button type="button" class="btn btn-sm btn-outline-primary" data-toggle="tooltip" data-placement="top" title="Adicionar Produto"
                                    @click="incluir_produto(dado)">
                                    <i class="fa fa-plus fa-fw" aria-hidden="true"></i>
                                </button>
                                <button type="button" class="btn btn-sm ml-2" 
                                    :class="dado.unidade_operacao_planos_count > 0 ? 'btn-outline-danger' : 'btn-outline-primary'"
                                    data-toggle="tooltip" data-placement="top" title="Lista Unidades"
                                    @click="listar_unidades(dado)" 
                                    disabled2="dado.produtos.length ? true : false">
                                    <i class="fa-regular fa-building fa-fw"></i>
                                </button>
                            </span>
                        </span>
                    </div>
                    <!-- Produto -->
                    <template v-if="dado.produtos.length && dado.proc_count">
                        <div class="small text-muted mt-2">Produtos</div>
                        <ul class="list-group">
                            <li class="list-group-item" v-for="(produto, ipdx) in lista_produtos(dado)" :key="id + '.' + ipdx">
                                <div class="d-flex justify-content-between">
                                    <a href="#" @click.prevent="editar_produto(dado, produto)">
                                        {{ produto.search }}
                                    </a>
                                    <span class="d-flex">
                                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                                            <input type="checkbox" class="custom-control-input" :id="'ativo-produto-' + id + '-' + ipdx" 
                                                v-model="produto.fl_ativo" 
                                                @change="toggle(produto)">
                                            <label class="custom-control-label" :for="'ativo-produto-' + id + '-' + ipdx"></label>
                                        </div>
                                        <span v-else>
                                            <span class="mr-3">{{ produto.st_codigo }}</span>

                                            <button type="button" class="btn btn-sm ml-2" 
                                                :class="produto.unidade_operacao_planos_count > 0 ? 'btn-outline-danger' : 'btn-outline-primary'"
                                                data-toggle="tooltip" data-placement="top" title="Lista Unidades" @click="listar_unidades(produto)">
                                                <i class="fa-regular fa-building fa-fw"></i>
                                            </button>
                                        </span>
                                    </span>
                                </div>
                            </li>
                        </ul>
                    </template>
                </li>
            </div>

        </div>

        <!-- Modal -->
        <div class="modal fade" id="planoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            Plano
                            {{ item.id_plano ? '#' + item.id_plano : '(Novo)' }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-8">
                                <az-input
                                    label="Nome do Plano"
                                    required 
                                    :validate="validate"
                                    v-model="item.st_plano" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    label="Código do Plano"
                                    :validate="validate"
                                    v-model="item.st_codigo" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Observações"
                                    :validate="validate"
                                    v-model="item.st_observacoes" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12 col-md-4">
                                <az-input
                                    type="number"
                                    label="Dígitos da Matrícula"
                                    placeholder="Conforme Operadora..."
                                    :validate="validate"
                                    v-model="item.in_digitos_matricula" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    label="Início da Matrícula"
                                    placeholder="Conforme Operadora..."
                                    :validate="validate"
                                    v-model="item.st_inicial_matricula" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    label="Id Externo"
                                    :validate="validate"
                                    v-model="item.st_id_externo" />
                            </div>
                        </div>

                        <div class="row" v-if="$store.state.user.id_usuario == 1">
                            <div class="col col-12">
                                <az-input
                                    label="Token de Integração"
                                    placeholder="Nenhum"
                                    :validate="validate"
                                    v-model="item.st_klingo_token" />
                            </div>
                        </div>

                        <div class="row" v-if="item.operadora && item.operadora.contrato_operadoras_count > 0">
                            <div class="col col-12">
                                <az-input
                                    label="Tipo de Reembolso"
                                    type="select"
                                    placeholder="Selecione..."
                                    :validate="validate"
                                    :optionsList="[
                                        { id: null, search: 'Padrão' }, 
                                        { id: 2, search: 'Reebmolso por Guia' }, 
                                        { id: 3, search: 'Reebmolso por Guia (com Pagamento)' }, 
                                    ]"
                                    optionsData="id"
                                    v-model="item.in_tipo_reembolso" />
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Valor Editável na Recepção"
                                    :validate="validate"
                                    v-model="item.fl_valor_editavel" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Bloquear localização de amostra"
                                    :validate="validate"
                                    v-model="item.fl_block_loc_amostra" />
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    type="number"
                                    label="Percentual de Coparticipação"
                                    :validate="validate"
                                    v-model="item.dc_copart_percent" />
                            </div>
                        </div>

                        <div v-if="1 == 0">
                            <div class="col col-12 col-md-6" v-if="1 == 0">
                                <az-input
                                    label="Limite sem Autorização"
                                    type="money"
                                    :validate="validate"
                                    v-model="item.dc_limite_sem_autorizacao" />
                            </div>
                            <div class="col col-12 col-md-4" v-if="1 == 0">
                                <az-input
                                    label="Status"
                                    type="select"
                                    optionsMode="json"
                                    :optionsList="[{ id: 'A', search: 'Ativo' }, { id: 'C', search: 'Cancelado' }, { id: 'S', search: 'Suspenso' }]"
                                    :validate="validate"
                                    v-model="item.ch_situacao" />
                            </div>
                        </div>


                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="plano" :id="item.id_plano" v-if="item && item.id_plano" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="produtoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content" v-if="produto">
                    <div class="modal-header">
                        <h5 class="modal-title">Produto do Plano {{ item ? item.st_plano : "" }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12 col-md-8">
                                <az-input
                                    label="Nome do Produto"
                                    required 
                                    :validate="validate"
                                    v-model="produto.st_plano" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    label="Código"
                                    required 
                                    :validate="validate"
                                    v-model="produto.st_codigo" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Observações"
                                    :validate="validate"
                                    v-model="produto.st_observacoes" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12 col-md-4">
                                <az-input
                                    type="number"
                                    label="Dígitos da Matrícula"
                                    placeholder="Conforme Operadora..."
                                    :validate="validate"
                                    v-model="produto.in_digitos_matricula" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    label="Início da Matrícula"
                                    placeholder="Conforme Operadora..."
                                    :validate="validate"
                                    v-model="produto.st_inicial_matricula" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    label="Id Externo"
                                    :validate="validate"
                                    v-model="produto.st_id_externo" />
                            </div>
                        </div>
                        
                        <div class="row mt-3">
                            <div class="col col-12">
                                <az-input
                                    type="checkbox-group"
                                    label="Valor Editável na Recepção"
                                    :validate="validate"
                                    v-model="produto.fl_valor_editavel" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="plano" :id="produto.id_plano" v-if="produto && produto.id_plano" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar_produto ()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Plano vs Unidade -->
        <div class="modal fade" id="planoUnidadeModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Unidades</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="lista_unidade_operacao_planos">

                        <button type="button" class="btn btn-primary btn-sm mb-3" @click="selecionar_unidade_todas()">Todas</button>

                        <div class="row" v-for="(und, iux) in lista_unidade_operacao_planos" :key="iux">
                            <div class="col col-12">
                                <az-input
                                    type="checkbox-group"
                                    :label="und.st_nome"
                                    v-model="und.plano.fl_ativo">
                                    <template v-slot:buttonposcb>
                                        <div class="input-group-append" v-if="und.plano.id_unidade_operacao_plano">
                                            <az-audit-log-button 
                                                model="unidadeOperacaoPlano" 
                                                :id="und.plano.id_unidade_operacao_plano" />
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar_plano_unidade()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzBreakTitle from '../../../util/AzBreakTitle.vue';
import AzEmptyState from '../../../util/AzEmptyState.vue';
import AzInput from '../../../shared/forms/AzInput.vue';
import AzSubmit from '../../../util/AzSubmit.vue';
import AzAuditLogButton from '../../../util/AzAuditLogButton.vue';
import Importacao from '../../shared/Importacao.vue';

export default {
    data () { 
        return { 
            dados: null, 
            search: "",
            item: null,  
            validate: false, 
            viewMode: "A",
            produto: null, 
            lista_unidade_operacao_planos: [],
        }
    },

    components: { 
        AzBreakTitle,
        AzEmptyState,
        AzInput,
        AzSubmit,
        AzAuditLogButton,
        Importacao
    }, 

    props: ['id_operadora'],

    computed: { 
        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter(item => this.viewMode == 'T' || item.fl_ativo )
                .filter (item => { 
                    return !this.search || reg.test(JSON.stringify(item));
                }) : null ; 
        }
    },

    methods: { 
        selecionar_unidade_todas() { 

            let selec = this.lista_unidade_operacao_planos.find(item => !item.plano.fl_ativo) ? true : false;

            this.lista_unidade_operacao_planos.forEach(item => {
                item.plano.fl_ativo = selec;
            });

        },

        atualizar_plano_unidade () { 
            this.$util.atualizar(this, {
                service: 'unidades',
                func: 'salvar_unidade_operacao_planos',
                dados: {
                    lista: this.lista_unidade_operacao_planos.map(item => {
                        return {  
                            unidade_operacao_plano: item.plano
                        };
                    }),
                },
                modal: 'planoUnidadeModal',
                reload: true, 
            });
        },

        listar_unidades (dado) { 

            $('.modal').modal('hide');
            this.validate = false;
            this.lista_unidade_operacao_planos = [];
            this.item = _.cloneDeep(dado);

            this.$util.load(this, {
                service: 'unidade_operacaos',
                func: 'index',
                parms: {
                    cadastro_plano: true,
                    id_plano: dado.id_plano,
                },
                loadTo: res => {
                    this.lista_unidade_operacao_planos = res;
                }
            });

            $('#planoUnidadeModal').modal('show');
        },

        collapse_planos(dado) { 
            dado.proc_count = !dado.proc_count;
            this.$forceUpdate();
        },
        
        lista_produtos (plano) { 
            return plano.produtos.filter(item => this.viewMode == 'T' || item.fl_ativo);
        },

        editar_produto (plano, produto) { 
            this.validate = false;
            this.item = plano;
            this.produto = _.cloneDeep(produto);

            $('#produtoModal').modal('show');
        },

        incluir_produto(plano) { 
            this.validate = false;
            this.item = plano;

            this.produto = {
                id_operadora: this.id_operadora,
                id_plano: null, 
                id_plano_pai: plano.id_plano, 
                fl_ativo: true, 
                st_plano: "",
                st_codigo: "", 
                ch_situacao: "A",
                dc_limite_sem_autorizacao: 0, 
            };

            $('#produtoModal').modal('show');
        },

        incluir () { 
            this.validate = false;
            
            this.item = { 
                id_operadora: this.id_operadora,
                id_plano: null,
                st_plano: "",
                fl_ativo: true,
                st_codigo: null, 
                ch_situacao: 'A',
                dc_limite_sem_autorizacao: 0, 
            }

            $('#planoModal').modal('show');

        },

        editar (item) { 

            this.validate = false;
            this.item = { ...item };

            $('#planoModal').modal('show');

        },

        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'planos',
                dados: item,
                callback: () => { 
                    this.$util.resync(this, 'planos.index');
                }
            });

        },

        atualizar_produto () { 

            this.$util.atualizar (this, { 
                service: 'planos',
                dados: this.produto,
                reload: true, 
                modal: 'produtoModal',
                callback: () => { 
                    this.$util.resync(this, 'planos.index');
                }
            });

        },

        atualizar () { 

            this.$util.atualizar (this, { 
                service: 'planos',
                dados: this.item,
                reload: true, 
                modal: 'planoModal',
                callback: () => { 
                    this.$util.resync(this, 'planos.index');
                }
            });

        },

        load () { 
            this.$store.commit('loading', true);

            let query = { q: [ 
                { 
                    name: 'planos.index',
                    id: 'lista',
                    parms: { 
                        where: { 
                            id_operadora: this.id_operadora,
                        },
                        cad_operadora: true, 
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.lista.status == 200 ) { 
                        this.dados = res.data.lista.data; 
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });
        }
    },

    created () { 
        this.$store.commit('loading', true);
    },

    mounted () { 
        this.load (); 
    }
}
</script>